import { Tooltip, UIText3 } from '@cian/ui-kit';
import { IconProductDocumentsVerified16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './DocumentsChecked.css';

type DocumentsCheckedProps = {
  text: string;
  type: 'label' | 'tooltip';
};

export const DocumentsChecked: FC<DocumentsCheckedProps> = props => {
  const { type, text } = props;

  const icon = <IconProductDocumentsVerified16 color="accent-main-primary" />;

  switch (type) {
    case 'label':
      return (
        <div className={styles['container']}>
          {icon}
          <UIText3>{text}</UIText3>
        </div>
      );

    case 'tooltip':
      return (
        <Tooltip placement="top-start" title={text}>
          {icon}
        </Tooltip>
      );
  }
};
